import { render, staticRenderFns } from "./ContractRecord.vue?vue&type=template&id=56c05086&scoped=true"
import script from "./ContractRecord.vue?vue&type=script&lang=js"
export * from "./ContractRecord.vue?vue&type=script&lang=js"
import style0 from "./ContractRecord.vue?vue&type=style&index=0&id=56c05086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c05086",
  null
  
)

export default component.exports